var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-navbar",
        {
          attrs: { id: "header", type: "light", variant: "light", sticky: "" }
        },
        [
          _c(
            "b-navbar-nav",
            { staticClass: "mr-2" },
            [
              _c(
                "b-button",
                {
                  attrs: { size: "sm", variant: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.onBack()
                    }
                  }
                },
                [
                  _c("font-awesome-icon", { attrs: { icon: "chevron-left" } }),
                  _vm._v("\n        Назад\n      ")
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-navbar-nav",
            { staticClass: "mx-2" },
            [
              _vm.isBusy
                ? [
                    _c(
                      "h4",
                      {
                        staticClass: "mb-0",
                        attrs: { id: "user-ellipsis-loading" }
                      },
                      [_vm._v("Загрузка пользователя")]
                    )
                  ]
                : [
                    _c("h4", [
                      _vm._v(
                        _vm._s(
                          _vm.user.name === ""
                            ? "Новый пользователь"
                            : _vm.user.name
                        )
                      )
                    ])
                  ]
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "b-navbar-nav",
            { staticClass: "ml-auto" },
            [
              _c(
                "b-row",
                { attrs: { "align-v": "center" } },
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "auto" } },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: {
                            size: "sm",
                            variant: "success",
                            disabled: _vm.loading
                          },
                          on: {
                            click: function($event) {
                              return _vm.onSubmit()
                            }
                          }
                        },
                        [
                          _vm.loading
                            ? _c("b-spinner", { attrs: { small: "" } })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("font-awesome-icon", {
                            staticClass: "mr-1",
                            attrs: { icon: "save" }
                          }),
                          _vm._v("\n            Сохранить\n          ")
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("b-skeleton-wrapper", {
        attrs: { loading: _vm.isBusy },
        scopedSlots: _vm._u([
          {
            key: "loading",
            fn: function() {
              return [
                _c(
                  "b-card",
                  { attrs: { "no-body": "" } },
                  [
                    _c(
                      "b-tabs",
                      { attrs: { card: "" } },
                      [
                        _c("b-tab", {
                          attrs: { title: "Учетные данные", disabled: "" }
                        }),
                        _vm._v(" "),
                        _c("b-tab", { attrs: { title: "Связи", disabled: "" } })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-card-body",
                      { attrs: { "border-variant": "white" } },
                      [
                        _c(
                          "b-row",
                          { staticClass: "pl-4 pr-4 pt-4 pb-3" },
                          [
                            _c(
                              "b-col",
                              { attrs: { lg: "6" } },
                              [
                                _c(
                                  "b-card",
                                  { attrs: { "bg-variant": "light" } },
                                  [
                                    _c(
                                      "b-row",
                                      { staticClass: "mb-2 mt-1" },
                                      [
                                        _c(
                                          "b-col",
                                          [
                                            _c("b-skeleton", {
                                              staticClass: "mb-2",
                                              attrs: {
                                                width: "29%",
                                                height: "24%"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("b-skeleton", {
                                              attrs: {
                                                type: "input",
                                                width: "100%",
                                                height: "45%"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-row",
                                      { staticClass: "mb-2" },
                                      [
                                        _c(
                                          "b-col",
                                          [
                                            _c("b-skeleton", {
                                              staticClass: "mb-2",
                                              attrs: {
                                                width: "30%",
                                                height: "24%"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("b-skeleton", {
                                              attrs: {
                                                type: "input",
                                                width: "100%",
                                                height: "45%"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-row",
                                      [
                                        _c(
                                          "b-col",
                                          [
                                            _c("b-skeleton", {
                                              staticClass: "mb-2",
                                              attrs: {
                                                width: "9%",
                                                height: "17%"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("b-skeleton", {
                                              staticClass: "mb-2",
                                              attrs: {
                                                type: "input",
                                                width: "100%",
                                                height: "31%"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("b-skeleton", {
                                              staticClass: "mb-0",
                                              attrs: {
                                                width: "86%",
                                                height: "16%"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-row",
                                      [
                                        _c(
                                          "b-col",
                                          [
                                            _c("b-skeleton", {
                                              attrs: {
                                                type: "input",
                                                width: "45%",
                                                height: "72%"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { lg: "6" } },
                              [
                                _c(
                                  "b-card",
                                  { attrs: { "bg-variant": "light" } },
                                  [
                                    _c(
                                      "b-row",
                                      { staticClass: "mt-1" },
                                      [
                                        _c(
                                          "b-col",
                                          [
                                            _c("b-skeleton", {
                                              staticClass: "mb-2",
                                              attrs: {
                                                width: "8%",
                                                height: "17%"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("b-skeleton", {
                                              staticClass: "mb-2",
                                              attrs: {
                                                type: "input",
                                                width: "100%",
                                                height: "30%"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("b-skeleton", {
                                              staticClass: "mb-0",
                                              attrs: {
                                                width: "21%",
                                                height: "16%"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-row",
                                      [
                                        _c(
                                          "b-col",
                                          [
                                            _c("b-skeleton", {
                                              staticClass: "mb-0",
                                              attrs: {
                                                type: "input",
                                                width: "59%",
                                                height: "45%"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            },
            proxy: true
          },
          {
            key: "default",
            fn: function() {
              return [
                _c(
                  "b-card",
                  { attrs: { "no-body": "" } },
                  [
                    _c(
                      "b-tabs",
                      { attrs: { card: "" } },
                      [
                        _c(
                          "b-tab",
                          { attrs: { title: "Учетные данные", active: "" } },
                          [
                            _c(
                              "b-card-body",
                              [
                                _c(
                                  "b-row",
                                  [
                                    _c(
                                      "b-col",
                                      { attrs: { lg: "6" } },
                                      [
                                        _c(
                                          "b-card",
                                          { attrs: { "bg-variant": "light" } },
                                          [
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  id: "group-name",
                                                  label: "Имя пользователя",
                                                  "invalid-feedback":
                                                    _vm.nameInvalidFeedback,
                                                  state: _vm.nameState
                                                }
                                              },
                                              [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    type: "text",
                                                    size: "sm",
                                                    state: _vm.nameState,
                                                    trim: ""
                                                  },
                                                  model: {
                                                    value: _vm.user.name,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.user,
                                                        "name",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "user.name"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  id: "group-email",
                                                  label: "Email пользователя",
                                                  "invalid-feedback":
                                                    _vm.emailInvalidFeedback,
                                                  state: _vm.emailState
                                                }
                                              },
                                              [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    type: "text",
                                                    size: "sm",
                                                    state: _vm.emailState,
                                                    trim: ""
                                                  },
                                                  model: {
                                                    value: _vm.user.email,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.user,
                                                        "email",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "user.email"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  id: "group-username",
                                                  label: "Логин",
                                                  description:
                                                    "Придумайте Логин. Будет использоваться для входа в систему",
                                                  "invalid-feedback":
                                                    _vm.userNameInvalidFeedback,
                                                  state: _vm.userNameState
                                                }
                                              },
                                              [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    type: "text",
                                                    size: "sm",
                                                    state: _vm.userNameState,
                                                    trim: ""
                                                  },
                                                  model: {
                                                    value: _vm.user.username,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.user,
                                                        "username",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "user.username"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _vm.isEdit
                                              ? _c(
                                                  "div",
                                                  [
                                                    _c(
                                                      "b-button",
                                                      {
                                                        attrs: {
                                                          size: "sm",
                                                          variant: "info"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            return _vm.onPasswordReset.apply(
                                                              null,
                                                              arguments
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Сгенерировать новый пароль"
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "strong",
                                                      { staticClass: "ml-2" },
                                                      [
                                                        _vm._v(
                                                          _vm._s(_vm.password)
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.password.length > 0
                                                      ? _c("b-form-text", [
                                                          _vm._v(
                                                            "Не забудьте скопировать пароль. Далее нажмите Сбросить пароль"
                                                          )
                                                        ])
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.password.length > 0
                                                      ? _c(
                                                          "b-button",
                                                          {
                                                            staticClass: "mt-2",
                                                            attrs: {
                                                              size: "sm",
                                                              variant: "danger"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                                return _vm.onChangePassword.apply(
                                                                  null,
                                                                  arguments
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Сбросить пароль"
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            !_vm.isEdit
                                              ? _c(
                                                  "b-form-group",
                                                  {
                                                    attrs: {
                                                      id: "group-password",
                                                      label: "Пароль",
                                                      description:
                                                        "Придумайте Пароль на Английском, минимум 6 символов. Будет использоваться для входа в систему",
                                                      "invalid-feedback":
                                                        _vm.passwordInvalidFeedback,
                                                      state: _vm.passwordState
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "b-input-group",
                                                      [
                                                        _c("b-form-input", {
                                                          attrs: {
                                                            type: "text",
                                                            size: "sm",
                                                            state:
                                                              _vm.passwordState,
                                                            trim: ""
                                                          },
                                                          model: {
                                                            value: _vm.password,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.password = $$v
                                                            },
                                                            expression:
                                                              "password"
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "b-input-group-append",
                                                          [
                                                            _c(
                                                              "b-button",
                                                              {
                                                                attrs: {
                                                                  size: "sm",
                                                                  variant:
                                                                    "info"
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    $event.stopPropagation()
                                                                    return _vm.onPasswordReset.apply(
                                                                      null,
                                                                      arguments
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Сгенерировать новый"
                                                                )
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c(
                                              "b-form-checkbox",
                                              {
                                                staticClass: "mt-2",
                                                model: {
                                                  value: _vm.user.active,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.user,
                                                      "active",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "user.active"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "Пользователь активен/не активен"
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("b-col", { attrs: { lg: "6" } })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-tab",
                          { attrs: { title: "Права доступа" } },
                          [
                            _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  { attrs: { lg: "6", md: "12" } },
                                  [
                                    _c(
                                      "b-card",
                                      { attrs: { "bg-variant": "light" } },
                                      [
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              id: "group-role",
                                              label: "Роль"
                                            }
                                          },
                                          [
                                            _c(
                                              "b-form-select",
                                              {
                                                attrs: { size: "sm" },
                                                on: {
                                                  change: _vm.onSelectRole
                                                },
                                                model: {
                                                  value: _vm.user.role,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.user,
                                                      "role",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "user.role"
                                                }
                                              },
                                              _vm._l(_vm.roles, function(
                                                option
                                              ) {
                                                return _c(
                                                  "option",
                                                  {
                                                    domProps: {
                                                      value: option.code
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(option.name) +
                                                        "\n                      "
                                                    )
                                                  ]
                                                )
                                              }),
                                              0
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("p", [_vm._v("Разрешения")]),
                                        _vm._v(" "),
                                        _c(
                                          "b-list-group",
                                          {
                                            staticClass: "text-small",
                                            attrs: { "bg-variant": "light" }
                                          },
                                          _vm._l(_vm.treeData, function(
                                            item,
                                            index
                                          ) {
                                            return _c("PermissionListItem", {
                                              key: index,
                                              attrs: {
                                                item: item,
                                                "tree-data": _vm.treeData
                                              }
                                            })
                                          }),
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("b-col", { attrs: { lg: "6", md: "12" } })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-tab",
                          { attrs: { title: "Связи" } },
                          [
                            _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  { attrs: { lg: "6", md: "12" } },
                                  [
                                    _c(
                                      "b-list-group",
                                      { attrs: { size: "sm" } },
                                      [
                                        _c(
                                          "b-list-group-item",
                                          {
                                            staticClass:
                                              "d-flex justify-content-between align-items-center",
                                            attrs: {
                                              variant: _vm.getStaffVariant()
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                    Штатный сотрудник\n                    "
                                            ),
                                            _c(
                                              "div",
                                              [
                                                _c("staff-select", {
                                                  ref: "staff_select",
                                                  on: {
                                                    onSelect: _vm.updateStaffId
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-54d8a8c2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54d8a8c2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Users/User.vue
// module id = null
// module chunks = 